"use client";

import { c as _c } from "react/compiler-runtime";
import UserPageStatsCollected from "./UserPageStatsCollected";
import UserPageActivityWrapper from "./activity/UserPageActivityWrapper";
import UserAddressesSelectDropdown from "../utils/addresses-select/UserAddressesSelectDropdown";
import UserPageStatsTags from "./tags/UserPageStatsTags";
import UserPageStatsActivityOverview from "./UserPageStatsActivityOverview";
import UserPageStatsBoostBreakdown from "./UserPageStatsBoostBreakdown";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { MemeSeason } from "@/entities/ISeason";
import type { ConsolidatedTDH, TDH } from "@/entities/ITDH";
import type { OwnerBalance, OwnerBalanceMemes } from "@/entities/IBalances";
import { useEffect, useMemo, useState } from "react";
import { commonApiFetch } from "@/services/api/common-api";
import { getStatsPath } from "./userPageStats.helpers";
import { isAddress } from "viem";
type Props = {
  readonly profile: ApiIdentity;
  readonly initialSeasons: MemeSeason[];
  readonly initialTdh?: ConsolidatedTDH | TDH | undefined;
  readonly initialOwnerBalance?: OwnerBalance | undefined;
  readonly initialBalanceMemes: OwnerBalanceMemes[];
};
export default function UserPageStatsClient(t0) {
  const $ = _c(61);
  const {
    profile,
    initialSeasons,
    initialTdh,
    initialOwnerBalance,
    initialBalanceMemes
  } = t0;
  const [activeAddress, setActiveAddress] = useState(null);
  const [seasons, setSeasons] = useState(initialSeasons);
  const [tdh, setTdh] = useState(initialTdh);
  const [ownerBalance, setOwnerBalance] = useState(initialOwnerBalance);
  const [balanceMemes, setBalanceMemes] = useState(initialBalanceMemes);
  let t1;
  if ($[0] !== activeAddress) {
    bb0: {
      if (!activeAddress) {
        t1 = null;
        break bb0;
      }
      const trimmed = activeAddress.trim();
      if (!isAddress(trimmed)) {
        t1 = null;
        break bb0;
      }
      t1 = trimmed.toLowerCase();
    }
    $[0] = activeAddress;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activeAddressForStats = t1;
  let t2;
  try {
    let t3;
    if ($[2] !== activeAddressForStats || $[3] !== profile) {
      t3 = getStatsPath(profile, activeAddressForStats);
      $[2] = activeAddressForStats;
      $[3] = profile;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = t3;
  } catch {
    t2 = null;
  }
  const statsPath = t2;
  let t3;
  let t4;
  if ($[5] !== initialSeasons) {
    t3 = () => setSeasons(initialSeasons);
    t4 = [initialSeasons];
    $[5] = initialSeasons;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[8] !== initialTdh) {
    t5 = () => setTdh(initialTdh);
    t6 = [initialTdh];
    $[8] = initialTdh;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[11] !== initialOwnerBalance) {
    t7 = () => setOwnerBalance(initialOwnerBalance);
    t8 = [initialOwnerBalance];
    $[11] = initialOwnerBalance;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[14] !== initialBalanceMemes) {
    t9 = () => setBalanceMemes(initialBalanceMemes);
    t10 = [initialBalanceMemes];
    $[14] = initialBalanceMemes;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[17] !== initialSeasons.length) {
    t11 = () => {
      const controller = new AbortController();
      if (initialSeasons.length > 0) {
        return () => controller.abort();
      }
      commonApiFetch({
        endpoint: "new_memes_seasons",
        signal: controller.signal
      }).then(setSeasons).catch(error => {
        if ((error as {
          name?: string | undefined;
        })?.name === "AbortError") {
          return;
        }
        setSeasons([]);
      });
      return () => controller.abort();
    };
    t12 = [initialSeasons.length];
    $[17] = initialSeasons.length;
    $[18] = t11;
    $[19] = t12;
  } else {
    t11 = $[18];
    t12 = $[19];
  }
  useEffect(t11, t12);
  let t13;
  let t14;
  if ($[20] !== activeAddressForStats || $[21] !== initialTdh || $[22] !== statsPath) {
    t13 = () => {
      const controller_0 = new AbortController();
      if (activeAddressForStats === null && initialTdh != null) {
        setTdh(initialTdh);
        return () => controller_0.abort();
      }
      if (statsPath === null) {
        setTdh(initialTdh);
        return () => controller_0.abort();
      }
      const url = `tdh/${statsPath}`;
      commonApiFetch({
        endpoint: url,
        signal: controller_0.signal
      }).then(setTdh).catch(error_0 => {
        if ((error_0 as {
          name?: string | undefined;
        })?.name === "AbortError") {
          return;
        }
        setTdh(undefined);
      });
      return () => controller_0.abort();
    };
    t14 = [activeAddressForStats, initialTdh, statsPath];
    $[20] = activeAddressForStats;
    $[21] = initialTdh;
    $[22] = statsPath;
    $[23] = t13;
    $[24] = t14;
  } else {
    t13 = $[23];
    t14 = $[24];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  if ($[25] !== activeAddressForStats || $[26] !== initialOwnerBalance || $[27] !== statsPath) {
    t15 = () => {
      const controller_1 = new AbortController();
      if (activeAddressForStats === null && initialOwnerBalance != null) {
        setOwnerBalance(initialOwnerBalance);
        return () => controller_1.abort();
      }
      if (statsPath === null) {
        setOwnerBalance(initialOwnerBalance);
        return () => controller_1.abort();
      }
      const url_0 = `owners-balances/${statsPath}`;
      commonApiFetch({
        endpoint: url_0,
        signal: controller_1.signal
      }).then(setOwnerBalance).catch(error_1 => {
        if ((error_1 as {
          name?: string | undefined;
        })?.name === "AbortError") {
          return;
        }
        setOwnerBalance(undefined);
      });
      return () => controller_1.abort();
    };
    t16 = [activeAddressForStats, initialOwnerBalance, statsPath];
    $[25] = activeAddressForStats;
    $[26] = initialOwnerBalance;
    $[27] = statsPath;
    $[28] = t15;
    $[29] = t16;
  } else {
    t15 = $[28];
    t16 = $[29];
  }
  useEffect(t15, t16);
  let t17;
  let t18;
  if ($[30] !== activeAddressForStats || $[31] !== initialBalanceMemes || $[32] !== statsPath) {
    t17 = () => {
      const controller_2 = new AbortController();
      if (activeAddressForStats === null && initialBalanceMemes != null) {
        setBalanceMemes(initialBalanceMemes);
        return () => controller_2.abort();
      }
      if (statsPath === null) {
        setBalanceMemes(initialBalanceMemes);
        return () => controller_2.abort();
      }
      const url_1 = `owners-balances/${statsPath}/memes`;
      commonApiFetch({
        endpoint: url_1,
        signal: controller_2.signal
      }).then(setBalanceMemes).catch(error_2 => {
        if ((error_2 as {
          name?: string | undefined;
        })?.name === "AbortError") {
          return;
        }
        setBalanceMemes([]);
      });
      return () => controller_2.abort();
    };
    t18 = [activeAddressForStats, initialBalanceMemes, statsPath];
    $[30] = activeAddressForStats;
    $[31] = initialBalanceMemes;
    $[32] = statsPath;
    $[33] = t17;
    $[34] = t18;
  } else {
    t17 = $[33];
    t18 = $[34];
  }
  useEffect(t17, t18);
  let t19;
  if ($[35] !== balanceMemes || $[36] !== ownerBalance) {
    t19 = <UserPageStatsTags ownerBalance={ownerBalance} balanceMemes={balanceMemes} />;
    $[35] = balanceMemes;
    $[36] = ownerBalance;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== profile.wallets) {
    t20 = profile.wallets ?? [];
    $[38] = profile.wallets;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t20) {
    t21 = <div><UserAddressesSelectDropdown wallets={t20} onActiveAddress={setActiveAddress} /></div>;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t19 || $[43] !== t21) {
    t22 = <div className="tw-flex-col-reverse tw-flex lg:tw-flex-row tw-justify-between tw-gap-6 lg:tw-space-y-0 tw-w-full tw-mt-6 lg:tw-mt-8">{t19}{t21}</div>;
    $[42] = t19;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== balanceMemes || $[46] !== ownerBalance || $[47] !== seasons) {
    t23 = <UserPageStatsCollected ownerBalance={ownerBalance} balanceMemes={balanceMemes} seasons={seasons} />;
    $[45] = balanceMemes;
    $[46] = ownerBalance;
    $[47] = seasons;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  let t25;
  if ($[49] !== activeAddressForStats || $[50] !== profile) {
    t24 = <UserPageStatsActivityOverview profile={profile} activeAddress={activeAddressForStats} />;
    t25 = <UserPageActivityWrapper profile={profile} activeAddress={activeAddressForStats} />;
    $[49] = activeAddressForStats;
    $[50] = profile;
    $[51] = t24;
    $[52] = t25;
  } else {
    t24 = $[51];
    t25 = $[52];
  }
  let t26;
  if ($[53] !== tdh) {
    t26 = <UserPageStatsBoostBreakdown tdh={tdh} />;
    $[53] = tdh;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t22 || $[56] !== t23 || $[57] !== t24 || $[58] !== t25 || $[59] !== t26) {
    t27 = <div className="tailwind-scope">{t22}{t23}{t24}{t25}{t26}</div>;
    $[55] = t22;
    $[56] = t23;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  return t27;
}